var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 31V28.5H43.5V21H41V28.5H31V21H28.5V28.5H21V31H28.5V41H21V43.5H28.5V51H31V43.5H41V51H43.5V43.5H51V41H43.5V31H51ZM41 41H31V31H41V41Z",
    fill: "#F24326"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHash);
export default __webpack_public_path__ + "static/media/hash.efdedef3fe8c7579a2772ceb5e12795d.svg";
export { ForwardRef as ReactComponent };